var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-eternity-tab__header"},[_vm._v(" You have "),_c('span',{staticClass:"c-eternity-tab__eternity-points"},[_vm._v(_vm._s(_vm.format(_vm.eternityPoints, 2)))]),_vm._v(" "+_vm._s(_vm.pluralize("Eternity Point", _vm.eternityPoints))+". ")])
}
var staticRenderFns = []

export { render, staticRenderFns }